"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChargingTransactionTelemetryTrackerValidation = void 0;
const ChargingTransactionTelemetryValidation_1 = require("./ChargingTransactionTelemetryValidation");
class ChargingTransactionTelemetryTrackerValidation {
    static isValid(entity) {
        // Validate entity.charging_transaction_telemetry for existence and correct type.
        if (entity.charging_transaction_telemetry == undefined)
            return false;
        if (!Array.isArray(entity.charging_transaction_telemetry))
            return false;
        if (!entity.charging_transaction_telemetry.every((elem) => {
            if (!ChargingTransactionTelemetryValidation_1.ChargingTransactionTelemetryValidation.isValid(elem))
                return false;
            return true;
        }))
            return false;
        return true;
    }
}
exports.ChargingTransactionTelemetryTrackerValidation = ChargingTransactionTelemetryTrackerValidation;
